import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiOnboardingReportParticipantDetailsComponent } from '@fi-app/fi-onboarding/fi-onboarding-report/fi-onboarding-report-participant-details/fi-onboarding-report-participant-details.component';
import { FiGradientCircleModule } from '@fi-shared/fi-gradient-circle/fi-gradient-circle.module';
import { MatCardModule } from '@angular/material/card';
import { FiProfileIconModule } from '@fi-shared/profile-icon/profile-icon.module';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { FiAppTextSharedModule } from '@fi-app/shared/app-text';
import { FiFormatDateModule } from '@fi-shared/fi-format-date/fi-format-date.module';
import { FiExpandableTextDirectiveModule } from '@fi-app/shared/fi-expandable-text-directive/fi-expandable-text-directive.module';
import { FiMatIconCheckboxMenuModule } from '@fi-shared/fi-mat-icon-checkbox-menu/fi-mat-icon-checkbox-menu.module';

@NgModule({
    imports: [
        CommonModule,
        FiGradientCircleModule,
        MatCardModule,
        FiProfileIconModule,
        MatIconModule,
        MatButtonModule,
        FiAppTextSharedModule,
        FiFormatDateModule,
        FiMatIconCheckboxMenuModule,
        FiExpandableTextDirectiveModule,
    ],
    declarations: [FiOnboardingReportParticipantDetailsComponent],
})
export class FiOnboardingReportParticipantDetailsModule {}
